/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { UpdateGroupInput, useUpdateGroupMutation } from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  onSuccess: () => void;
};

export function useUpdateResourceGroupInResource({ onSuccess }: Props) {
  const [updateGroupMutation, { loading }] = useUpdateGroupMutation({
    onCompleted: (data) => {
      if (data.updateGroup) {
        onSuccess();
      }
    },
    onError: (error) => {
      showError(error.message);
    },
  });

  async function updateGroup(data: UpdateGroupInput) {
    updateGroupMutation({
      variables: {
        input: data,
      },
    });
  }

  return { updateGroup, loading } as const;
}
